// src/services/cartPersistenceApi.js
// API client pour la persistance des paniers temporaires

const API_BASE = process.env.REACT_APP_LOCAL_API || '/api';

// Générer un token de session unique
export const generateSessionToken = () => {
    return `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
};

// Sauvegarder un panier temporaire
export async function saveCartSession({ 
    clientEmail, 
    sessionToken, 
    cartData
}) {
    try {
        const response = await fetch(`${API_BASE}/cart/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                client_email: clientEmail,
                session_token: sessionToken,
                cart_data: cartData
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();return result;
    } catch (error) {
        console.error('❌ Erreur sauvegarde panier:', error);
        throw new Error(`Erreur sauvegarde panier: ${error.message}`);
    }
}

// Charger un panier temporaire
export async function loadCartSession(clientEmail, sessionToken) {
    try {
        const response = await fetch(`${API_BASE}/cart/load/${encodeURIComponent(clientEmail)}/${sessionToken}`);
        
        if (response.status === 404) {
            // Panier non trouvé - normal
            return { 
                success: false, 
                cart_data: [], 
                message: 'Aucun panier sauvegardé trouvé' 
            };
        }

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();return result;
    } catch (error) {
        console.error('❌ Erreur chargement panier:', error);
        throw new Error(`Erreur chargement panier: ${error.message}`);
    }
}

// Supprimer un panier après envoi réussi
export async function clearCartSession(clientEmail, sessionToken, reason = 'quotation_sent') {
    try {
        const response = await fetch(`${API_BASE}/cart/clear/${encodeURIComponent(clientEmail)}/${sessionToken}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ reason })
        });

        if (response.status === 404) {
            // Panier déjà supprimé - pas grave
            return { 
                success: true, 
                message: 'Panier déjà supprimé' 
            };
        }

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();return result;
    } catch (error) {
        console.error('❌ Erreur suppression panier:', error);
        throw new Error(`Erreur suppression panier: ${error.message}`);
    }
}

// ADMIN: Lister tous les paniers en cours
export async function getActiveCartSessions() {
    try {
        const response = await fetch(`${API_BASE}/cart/admin/list`);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();return result;
    } catch (error) {
        console.error('❌ Erreur liste paniers admin:', error);
        throw new Error(`Erreur liste paniers: ${error.message}`);
    }
}
